import { render } from "./ImageEnlarger.vue?vue&type=template&id=0c47825a&scoped=true"
import script from "./ImageEnlarger.vue?vue&type=script&lang=js"
export * from "./ImageEnlarger.vue?vue&type=script&lang=js"

import "./ImageEnlarger.vue?vue&type=style&index=0&id=0c47825a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c47825a"]])

export default __exports__